import { createSvgIcon } from '@mui/material/utils'

export const Currency = createSvgIcon(
  <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path d='M5 13.3327C5 15.1736 6.49238 16.666 8.33333 16.666H11.6667C13.5076 16.666 15 15.1736 15 13.3327C15 11.4917 13.5076 9.99935 11.6667 9.99935H8.33333C6.49238 9.99935 5 8.50696 5 6.66602C5 4.82507 6.49238 3.33268 8.33333 3.33268H11.6667C13.5076 3.33268 15 4.82507 15 6.66602M10 1.66602V18.3327' stroke-width='1.67' stroke-linecap='round' />
  </svg>
)
